import { createContext, useEffect, useState } from 'react';

type ContextValueType = string;

enum AliasGroups {
  DEFAULT = 'default',
}

const localStorageKey = 'alias-group';

const getInitialState = (): ContextValueType => {
  const storedGroup = localStorage.getItem(localStorageKey);
  return storedGroup ? storedGroup : AliasGroups.DEFAULT;
};

const AliasGroupContext = createContext<
  [ContextValueType, React.Dispatch<React.SetStateAction<ContextValueType>>]
>([AliasGroups.DEFAULT, () => {}]);

const AliasGroupContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [aliasGroup, setAliasGroup] = useState(getInitialState());

  useEffect(() => {
    localStorage.setItem(localStorageKey, aliasGroup);
  }, [aliasGroup]);

  return (
    <AliasGroupContext.Provider value={[aliasGroup, setAliasGroup]}>
      {children}
    </AliasGroupContext.Provider>
  );
};

export { AliasGroupContext, AliasGroups };
export default AliasGroupContextProvider;
